var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBagShopDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64908 12.3978C3.78198 7.58193 7.3996 3.85838 11.9883 2.7851L12.7527 2.60631C16.209 1.7979 19.791 1.7979 23.2473 2.60631L24.0117 2.7851C28.6004 3.85838 32.218 7.58193 33.3509 12.3978C34.2164 16.0767 34.2164 19.9233 33.3509 23.6022C32.218 28.4181 28.6004 32.1416 24.0117 33.2149L23.2473 33.3937C19.791 34.2021 16.209 34.2021 12.7527 33.3937L11.9883 33.2149C7.3996 32.1416 3.78198 28.4181 2.64908 23.6022C1.78364 19.9233 1.78364 16.0767 2.64908 12.3978Z",
    fill: "#FCFCFC",
    stroke: "#B0B0B0",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.3919V13.5836C14.25 11.7086 15.7583 9.86692 17.6333 9.69192C19.8667 9.47525 21.75 11.2336 21.75 13.4253V14.5753",
    stroke: "#B0B0B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 26.3327H20.5001C23.8501 26.3327 24.4501 24.991 24.6251 23.3577L25.2501 18.3577C25.4751 16.3243 24.8918 14.666 21.3334 14.666H14.6668C11.1084 14.666 10.5251 16.3243 10.7501 18.3577L11.3751 23.3577C11.5501 24.991 12.1501 26.3327 15.5001 26.3327Z",
    stroke: "#B0B0B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9128 18.0007H20.9203",
    stroke: "#B0B0B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0788 18.0007H15.0863",
    stroke: "#B0B0B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBagShopDisabled);
export default __webpack_public_path__ + "static/media/icon-BagShopDisabled.06ded8e65ab21b665982496763e89987.svg";
export { ForwardRef as ReactComponent };